/**
 * GuidedModeToggle — switch « mode guidé » dans le header (SAAS-740).
 *
 * @remarks
 * Ne s'affiche QUE sur la page d'évaluation (`tech-test-evaluation`) : c'est
 * l'entrée du tour `evaluation`. Modelé sur `ThemeToggle` (composant `app/`
 * transverse qui lit/écrit un store `app/stores/`). Activer le switch lance le
 * tour ; il repasse OFF tout seul quand le tour se ferme.
 */

import { Compass } from 'lucide-react';
import { Toggle } from '@/shared/ui';
import { useCurrentContext } from '@/app/router/use-current-context';
import { useGuidedTourStore } from '@/app/stores/use-guided-tour-store';
import { EVALUATION_CONTEXT } from './evaluation-steps';
import { TOUR_IDS } from './tour-types';
import { useGuidedTour } from './use-guided-tour';

export function GuidedModeToggle() {
  const context = useCurrentContext();
  const activeTourId = useGuidedTourStore((s) => s.activeTourId);
  const { startTour, stopTour } = useGuidedTour();

  // Le mode guidé n'existe que pendant une évaluation.
  if (context !== EVALUATION_CONTEXT) return null;

  const handleChange = (next: boolean) => {
    if (next) void startTour(TOUR_IDS.EVALUATION);
    else stopTour();
  };

  return (
    <span className="flex items-center gap-1.5">
      <Compass className="text-fg-muted size-4" aria-hidden />
      <Toggle
        checked={activeTourId === TOUR_IDS.EVALUATION}
        onCheckedChange={handleChange}
        size="sm"
        aria-label="Mode guidé"
        title="Mode guidé"
      />
    </span>
  );
}
